import { ProjectMembers } from "@/components/cards";
import { Address } from "@msuite/ui/address";
import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { WorkspaceTag } from "@msuite/ui/tag";
import { guardString } from "@msuite/utils/strings";
import type { Nullable, ProjectCard as ProjectCardType } from "@msuite/utils/types";
import { ProjectClient } from "../project-client";

/** Props Interface */
export interface ProjectHeaderProps {
	project: Nullable<ProjectCardType>;
}

export function ProjectHeader({ project }: ProjectHeaderProps) {
	/** Guard */
	if (!project) return null;

	/** Render */
	return (
		<ContentCard
			icon={icon("FolderOpen")}
			title={project.name}
			identifier={project.id}
		>
			<div
				className="v-stack"
				data-projectName={project.name}
			>
				<div className="justify-between h-stack">
					{project.clientId ? (
						<ProjectClient client={project._client} />
					) : (
						<p>{guardString(null)}</p>
					)}
					<p>{project.number}</p>
				</div>
				<div className="justify-between h-stack">
					<Address item={project} />
					<div className="h-stack gap-6">
						<WorkspaceTag workspace={project._workspace} />
						<ProjectMembers
							members={project._members}
							justify="start"
						/>
					</div>
				</div>
			</div>
		</ContentCard>
	);
}
